export default __webpack_public_path__ + "static/media/iq-img3.890f4fb8.png";